import React from 'react';
import ScaleLoader from 'react-spinners/ScaleLoader';
import './Loading.css'



class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    }
  }
  render() {
    return (
      <div className='sweet-loading'>
        <ScaleLoader
         
          sizeUnit={"px"}
          size={500}
          color={'#4f9cda'}
          height={70}
          loading={this.state.loading}
        />
        <p>Loading . . .</p>
        <p>Please wait. It will only take a moment.</p>
      </div> 
    )
  }
}

export default Loading;